import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import { useEffect, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { ProductDetails } from "../components/product_details"
import { useCookies } from "react-cookie"
import { useNavigate } from "react-router-dom"

export default function MyCart() {
    const [pageLoading, setPageLoading] = useState(false);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount } = useCart();
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [cookies] = useCookies();
    const navigate = useNavigate();
    const [cartItems, setCartItems] = useState(Array.isArray(cookies.myCart) ? cookies.myCart : []);
    const [stockQty, setStockQty] = useState({});

    useEffect(() => {
        if (!cartItems?.length) return;

        const stockMap = {};

        cartItems.forEach(item => {
            stockMap[item.product_id] = getStock(item.product_id, item.selected);
        });

        setStockQty(stockMap);
    }, [cartItems]);

    useEffect(() => {
        setCartItems(cookies?.myCart);
        console.log(cookies?.myCart)
    }, [cookies?.myCart])

    const calculateItemPrice = (item) => {
        const extrasTotal = Object.values(item.selected || {}).reduce(
        (sum, opt) => sum + Number(opt.amount_plus),
        0
        );

        return item.total_price;
    };

    const subtotal = cartItems?.reduce(
        (sum, item) => sum + calculateItemPrice(item),
        0
    );

    async function getStock(prod_id, selected) {
        const formData = new FormData();
        formData.append('product_id', prod_id);
        formData.append('selected', JSON.stringify(selected));

        try {
            const response = await axios.post(base_url + '/get_item_stock.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data.status) {
                return response.data.in_stock;
            } else {
                return 'N/A'
            }
        } catch (error) {
          return 'N/A'
        }
    }

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            {showModal &&
            <ProductDetails 
                setShowModal={setShowModal}
                showModal={showModal}
                showDetails={showDetails}
            />
            }
            <Navbar />
            <div className="max-w-7xl mx-auto px-4 py-6">
                <h1 className="text-2xl font-semibold mb-6">Shopping Cart</h1>

                {/* Cart Table */}
                <div className="space-y-6">
                    {cartItems?.map((item, index) => (
                    <div
                        key={index}
                        className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6 border rounded-lg p-4"
                    >
                        {/* Product */}
                        <div className="flex items-center gap-4 md:w-1/3">
                        <button
                            onClick={() => removeItem(item.product_id)}
                            className="text-red-500 text-2xl"
                        >
                            ×
                        </button>

                        <img
                            src={item.thumbnail}
                            alt={item.name}
                            className="w-16 h-16 object-contain"
                        />

                        <div>
                            <p className="font-medium">{item.name} ({item.quantity})</p>

                            {/* Extras */}
                            <ul className="text-sm text-gray-500 mt-1">
                            {Object.entries(item.selected || {}).map(
                                ([key, val]) => (
                                <li key={key}>
                                    {key}: {val.option}
                                </li>
                                )
                            )}
                            </ul>
                        </div>
                        </div>

                        {/* Price */}
                        <div className="md:w-1/6 font-medium">
                        {convertAmount(item.total_price)}
                        </div>

                        
                        {/* Quantity */}
                        {/* <div className="md:w-1/6">
                        <input
                            type="number"
                            min="1"
                            value={item.quantity}
                            onChange={(e) =>
                            updateQty(index, Number(e.target.value))
                            }
                            className="w-20 border rounded px-2 py-1"
                        />
                        </div> */}

                        {/* Subtotal */}
                        <div className="md:w-1/6 font-semibold">
                        {convertAmount(item.total_price)}
                        </div>

                        {/* In Stock */}
                        <div className="md:w-1/6 font-medium">
                        {stockQty?.[item.product_id] ?? 'Checking stock..'}
                        </div>

                        <div className="md:w-1/6 font-medium">
                        <button onClick={() => {setShowModal(true);setShowDetails({ name: item.name, product_id: item.product_id }) }} className="bg-[#fc8c06] text-white py-2 px-5 rounded-sm">Modify Selection</button>
                        </div>
                    </div>
                    ))}
                </div>
                <div className="flex">
                    <button onClick={() => navigate('/shop-now')} className="py-2 px-5 border rounded-sm my-2">Return to Shop</button>
                </div>
                {/* Bottom Section */}
                <div className="grid md:grid-cols-2 gap-8 mt-10">
                    {/* Coupon */}
                    <div className="order-2 md:order-1 flex flex-col gap-2">
                        <p className="text-xl font-semibold mb-2">Policies</p>
                        <p className="text-md font-semibold text-[#232323]">Exchanges & Refund</p>
                        <p className="text-sm text-[#232323]">
                            To be eligible for an exchange or refund, your item must be unused and in the same condition that you received it. It must also be in the original packaging untampered.
                            To complete your exchange, we require a receipt or proof of purchase
                            Make sure you read our full exchange and refund policy here before you place an order
                            <br/><a href="/refund-policy" className="underline text-[#7d5af6]">Read our refund policy</a>
                        </p>
                        <p className="text-md font-semibold text-[#232323]">Shipping</p>
                        <p className="text-sm text-[#232323]">
                            We ship worldwide using renowned service providers
                            <br/><a href="/shipping-policy" className="underline text-[#7d5af6]">Read our shipping policy</a>
                        </p>
                        <p className="text-md font-semibold text-[#232323]">Need help?</p>
                        <p className="text-sm text-[#232323]">
                            We are more than happy to talk to you
                            <br/><a href="https://api.whatsapp.com/message/EJMNVMDG22ZTP1?autoload=1&app_absent=0%0A" target="_blank" className="underline text-[#7d5af6]">Text our Whatsapp on +234 813-883-7980</a>
                        </p>
                    </div>

                    {/* Totals */}
                    {cookies?.myCart?.length > 0 &&
                    <div className="order-1 md:order-2 border rounded-lg p-6">
                        <h2 className="font-semibold text-lg mb-4">
                            Cart Total
                        </h2>

                        <div className="flex justify-between mb-2">
                            <span>Subtotal</span>
                            <span>{convertAmount(subtotal)}</span>
                        </div>

                        <div className="flex justify-between mb-2">
                            <span>Shipping</span>
                            <span>To Be Calculated</span>
                        </div>

                        <div className="border-t my-3"></div>

                        <div className="flex justify-between font-semibold text-lg">
                            <span>Total</span>
                            <span>{convertAmount(subtotal)}</span>
                        </div>

                        <button onClick={() => navigate('/checkout')} className="mt-6 w-full bg-[#7d5af6] text-white py-3 rounded">
                            Proceed to checkout
                        </button>
                    </div>
                    }
                </div>
            </div>
            <Footer />
        </div>
    )
}